// extracted by mini-css-extract-plugin
module.exports = {"load":"LoadButton_load__2lLW9"};